import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ar-receipt-form',
  templateUrl: './ar-receipt-form.component.html',
  styleUrls: ['./ar-receipt-form.component.css']
})
export class ArReceiptFormComponent implements OnInit {
  title="Accounts Receivable Receipt";
  paymentMode : any;
  constructor() { }

  ngOnInit() {
  }
  
  selectPaymentMode(event){
    this.paymentMode = event.target.value;
  }

}



// WEBPACK FOOTER //
// ./src/app/Pages/sales-orders/accounts-receivable-receipt/ar-receipt-form/ar-receipt-form.component.ts